export default __webpack_public_path__ + "static/help_06_02-1-f01dc60606b1e69d8b87827dd4c4827a.png";